import { supabase } from '@/lib/supabase';

type UpdateTrackingReportInput = {
  currReportId: number;
  description: string;
  kpiValues: Record<number, string>;
  documentIds?: number[];
};

export const updateTrackingReport = async (
  input: UpdateTrackingReportInput,
): Promise<number> => {
  const { currReportId, description, kpiValues, documentIds = [] } = input;

  const kpiEntries = Object.entries(kpiValues)
    .filter(([, value]) => value.trim() !== '')
    .map(([kpiId, value]) => ({
      kpi_id: parseInt(kpiId),
      value: parseFloat(value) || 0,
    }));

  const { data: reportId, error } = await supabase.rpc(
    'update_tracking_report',
    {
      p_report_id: currReportId,
      p_description: description,
      p_kpi_entries: kpiEntries,
      p_document_ids: documentIds,
    },
  );

  if (error) {
    throw error;
  }

  return reportId;
};
